"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = exports.i18n = void 0;
var mithril_1 = __importDefault(require("mithril"));
exports.i18n = {
    defaultLocale: '',
    currentLocale: '',
    locales: {},
    messages: {},
    onChangeLocale: [],
    status: 'uninitialized',
    init: init,
    t: t,
    number: number,
    date: date,
    loadAndSetLocale: loadAndSetLocale,
    supported: supported,
    dir: dir,
    addOnChangeListener: addOnChangeListener,
    removeOnChangeListener: removeOnChangeListener,
};
function init(locales, selectedLocale) {
    return __awaiter(this, void 0, void 0, function () {
        var defaultLocale;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    exports.i18n.locales = locales;
                    defaultLocale = Object.keys(locales)
                        .filter(function (l) { return locales[l].default; })
                        .shift();
                    if (defaultLocale) {
                        exports.i18n.defaultLocale = defaultLocale || selectedLocale;
                    }
                    return [4 /*yield*/, loadAndSetLocale(selectedLocale)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function pluralForm(message, count) {
    if (typeof message === 'string' || typeof message === 'undefined') {
        return message;
    }
    var rules = new Intl.PluralRules(exports.i18n.currentLocale);
    return message.plural[rules.select(count)];
}
function number(num, options) {
    if (options === void 0) { options = {}; }
    var formatter = new Intl.NumberFormat(exports.i18n.locales[exports.i18n.currentLocale].fqn, options);
    return formatter.format(num);
}
function date(date, options) {
    if (options === void 0) { options = {}; }
    var formatter = new Intl.DateTimeFormat(exports.i18n.locales[exports.i18n.currentLocale].fqn, options);
    return formatter.format(new Date(date));
}
function interpolate(message, interpolations) {
    return Object.keys(interpolations).reduce(function (msg, variableName) {
        return msg.replace(new RegExp("{\\s*".concat(variableName, "\\s*}"), 'g'), interpolations[variableName].toString());
    }, message);
}
function formatNumbersInObject(obj) {
    var result = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        result[key] = typeof value === 'number' ? number(value) : value;
    });
    return result;
}
function loadAndSetLocale(newLocale) {
    return __awaiter(this, void 0, void 0, function () {
        var resolvedLocale;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (exports.i18n.currentLocale === newLocale) {
                        return [2 /*return*/];
                    }
                    resolvedLocale = supported(newLocale) ? newLocale : exports.i18n.defaultLocale;
                    exports.i18n.status = 'loading';
                    return [4 /*yield*/, fetchMessages(resolvedLocale, function (messages) {
                            exports.i18n.messages = messages;
                            exports.i18n.currentLocale = resolvedLocale;
                            exports.i18n.status = 'idle';
                            exports.i18n.onChangeLocale.forEach(function (listener) { return listener(exports.i18n.currentLocale, dir()); });
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function supported(locale) {
    return Object.keys(exports.i18n.locales).indexOf(locale) >= 0;
}
function dir(locale) {
    if (locale === void 0) { locale = exports.i18n.currentLocale; }
    return exports.i18n.locales[locale].dir || 'ltr';
}
function fetchMessages(locale, onComplete) {
    return __awaiter(this, void 0, void 0, function () {
        var messages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mithril_1.default.request((exports.i18n.locales.url || '/lang/{locale}.json').replace('{locale}', locale))];
                case 1:
                    messages = _a.sent();
                    onComplete(messages);
                    return [2 /*return*/];
            }
        });
    });
}
function addOnChangeListener(listener) {
    exports.i18n.onChangeLocale.push(listener);
}
function removeOnChangeListener(listener) {
    exports.i18n.onChangeLocale = exports.i18n.onChangeLocale.filter(function (currentListener) { return currentListener !== listener; });
}
function t(key, interpolations) {
    if (interpolations === void 0) { interpolations = {}; }
    var message = exports.i18n.messages[key] || key;
    var pluralizedMessage = pluralForm(message, interpolations.count);
    var numberFormattedInterpolations = formatNumbersInObject(interpolations);
    return interpolate(pluralizedMessage, numberFormattedInterpolations);
}
exports.t = t;
//# sourceMappingURL=i18n.js.map